exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.season[data-v-3cac61bb]{position:relative\n}\n@media (min-width:700px){\n.season[data-v-3cac61bb]{display:grid;grid-gap:15px;grid-template-columns:repeat(4,1fr) 100px\n}\n.season hr[data-v-3cac61bb]{grid-column:1/-1;margin:0 0 30px\n}\n.season p[data-v-3cac61bb]{margin:0\n}\n.season>label[data-v-3cac61bb]{padding-top:40px\n}\n}", ""]);

// exports
